export const downLoadCsvFile = (data, filename = 'data') => {
  if (!data || data.length === 0) return;

  const headers = Object.keys(data[0]).join(',');
  const csvContent = [
    headers,
    ...data.map((e) =>
      Object.values(e)
        .map((value) => `"${value}"`)
        .join(','),
    ),
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.setAttribute('download', `${filename}.csv`);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
